import React from 'react';
import Layout from '../../components/Layout';
import NewsArchive from './NewsArchive';
import moment from 'moment';

const title = 'NewsArchive';

async function action(context) {
  const { month, id } = context.params;

  // Bots/broken external links hit /publications/N/archives/null (or other
  // garbage). moment("null") is invalid → MySQL throws "Incorrect DATETIME
  // value" → the render then dereferences null. Reject upfront.
  if (!moment(month).isValid() || !/^\d+$/.test(id)) {
    return { redirect: '/not-found' };
  }

  const startDate = moment(month)
    .startOf('month')
    .format('YYYY-MM-DD HH:mm:ss');
  const endDate = moment(month)
    .endOf('month')
    .format('YYYY-MM-DD HH:mm:ss');

  const publicationsText = id != 0 ? `publications:"${id}"` : '';

  const newsResp = await context.fetch('/graphql', {
    body: JSON.stringify({
      query: `
      { newsBetween(startDate:"${startDate}", endDate:"${endDate}", ${publicationsText}) {
          items {
            title date id author blurb blurb_image_uid blurb_expanded_image_uid
            article article_image_uid article_expanded_image_uid article_image_caption
            tags publications category
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            totalCount
            totalPages
            currentIndex
          }
        }
      }
      `,
    }),
  });

  const { data } = await newsResp.json();

  const pubResp = await context.fetch('/graphql', {
    body: JSON.stringify({
      query: `{publications(id:${id}){id, name, banner_image_uid, mast_head_uid, write_up, short_name, editor_id,
      group_marketing_manager_id}}`,
    }),
  });

  const pub = await pubResp.json();
  const publication = pub && pub.data && pub.data.publications && pub.data.publications[0];
  if (!publication) {
    return { redirect: '/not-found' };
  }

  return {
    chunks: ['newsArchive'],
    title,
    component: (
      <Layout publication={publication}>
        <NewsArchive
          period={month}
          news={(data && data.newsBetween && data.newsBetween.items) || []}
          publication={id}
        />
      </Layout>
    ),
  };
}

export default action;
